import React, { useState } from 'react';
import { FaPaperPlane } from 'react-icons/fa';
import { reachGoal } from '../utils/metrika';
import { formatPhoneInput } from '../utils/phoneMask';
import ConsentCheckbox from './ConsentCheckbox';
import './ContactForm.css';

const ContactForm = () => {
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handlePhoneChange = (e) => {
    setPhone(formatPhoneInput(e.target.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const apiUrl = window.location.port === '3000' ? 'http://localhost:5000/api/contact' : '/api/contact';
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: 'Заявка с сайта (форма внизу)',
          phone,
          email: '',
          message: '',
          pageUrl: window.location.href,
        }),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setPhone('');
        reachGoal('form-footer');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact-form" className="contact-form-section">
      <div className="contact-form-title-section">
        <div className="container-custom">
          <h2 className="contact-form-main-title">свяжитесь с нами</h2>
        </div>
      </div>
      
      <div className="contact-form-wrapper-section">
        <div className="container-custom">
          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="phone">Телефон *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={phone}
                  onChange={handlePhoneChange}
                  required
                  placeholder="+7 (___) ___-__-__"
                />
              </div>

              <ConsentCheckbox />

              <button type="submit" className="form-submit-btn" disabled={isSubmitting}>
                {isSubmitting ? 'Отправка...' : (
                  <>
                    Отправить заявку <FaPaperPlane />
                  </>
                )}
              </button>
              
              {submitStatus === 'success' && (
                <div className="form-status success">
                  Заявка отправлена! Мы свяжемся с вами в ближайшее время.
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="form-status error">
                  Произошла ошибка. Пожалуйста, попробуйте ещё раз или свяжитесь с нами по телефону.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
